import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderEn = () => {
    return (
        <HighlightedText
            text="SCRATCH THE TICKETS AND GET YOUR BONUS"
            highlights={[{ word: 'GET YOUR BONUS' }]}
            breakAfterWords={['TICKETS']}
            className={styles.text_header}
        />
    )
}
